<template>
    <div class="container offset">
        <form @submit.prevent>
        <div class="custom-form ">  
            <div class="form-group">
                <label class="question-style pt-1">Nome:</label>
                <input
                    v-model="userInfo.nome"
                    type="name"
                    class="form-control input-personal"
                    required
                />
            </div>

            <div class="form-group">
                <label class="question-style pt-1">Email:</label>
                <input
                    v-model="userInfo.email"
                    type="name"
                    class="form-control input-personal disabled-style"
                    required
                />
            </div>
            <label>Gênero</label>
            <div class="form-group">
                    <div class="form-inline">
                    <div class="form-check mr-3">
                        <input v-model="userInfo.genero" class="form-check-input" type="radio" name="genero" id="masculino_profile" value="MASCULINO" required>
                        <label class="form-check-label">Masculino</label>    
                    </div>

                    <div class="form-check mr-3">
                        <input v-model="userInfo.genero" class="form-check-input" type="radio" name="genero" id="feminino_profile" value="FEMININO">
                        <label class="form-check-label">Feminino</label>
                    </div>

                    <div class="form-check">
                        <input v-model="userInfo.genero" class="form-check-input" type="radio" name="genero" id="outro_profile" value="OUTRO">
                        <label class="form-check-label">Outro</label>
                    </div>
            </div>
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Data de Nascimento:</label>
                <input
                    v-model="userInfo.dataNascimento"
                    type="date"
                    class="form-control input-personal"
                    required
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Formação:</label>
                <input
                    v-model="userInfo.formacao"
                    type="name"
                    class="form-control input-personal"
                    required
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Telefone:</label>
                <input
                    pattern="^(?:[1-9]{2}| ?) ?(?:[1-9]|[1-9][1-9])[0-9]{3}-?[0-9]{4}$"
                    @change="mascaraTelChange()" @keyup="mascaraTel()"
                    placeholder="XX XXXXX-XXXX"
                    maxlength="13"
                    v-model="userInfo.telefone"
                    type="name"
                    class="form-control input-personal"
                    required
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Estado:</label>
                <select
                    v-model="userInfo.estado"
                    class="form-control"
                    id="perfilEstado"
                    required
                >
                    <option v-for="estado in estados_brasileiros" :key="estado" :value="estado">{{estado}}</option>
                </select>
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Cidade:</label>
                <input
                    v-model="userInfo.cidade"
                    type="name"
                    class="form-control input-personal"
                    required
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Sede ou Distrito:</label>
                <input
                    v-model="userInfo.distrito"
                    type="name"
                    class="form-control input-personal"
                    required
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">CEP:</label>
                <input
                    v-model="userInfo.cep"
                    placeholder="Insira seu CEP"
                    maxlength="10" 
                    @keyup="mascaraCEP()" 
                    @change="mascaraCepChange()"
                    type="text"
                    class="form-control input-personal"
                    required
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Logradouro:</label>
                <input
                    v-model="userInfo.logradouro"
                    type="name"
                    class="form-control input-personal"
                    required
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Número:</label>
                <input
                    v-model="userInfo.numero"
                    type="name"
                    class="form-control input-personal"
                />
            </div>
            <div class="form-group">
                <label class="question-style pt-1">Bairro:</label>
                <input
                    v-model="userInfo.bairro"
                    type="name"
                    class="form-control input-personal"
                    required
                />
            </div>

            <div class="button-div d-flex flex-row-reverse">
                <Button 
                    @click="updateUser"
                    section="salvar"
                    value="Salvar"
                    :isOutline="true"
                    :hasIcon="true"
                    iconName="save"
                /> 
                <Button 
                    @click="close"
                    section="descartar"
                    value="Descartar"
                    :isOutline="true"
                    :hasIcon="true"
                    iconName="times"
                /> 
                
            </div>
        </div>
        </form>
    </div>
</template>

<script>

import Button from '../../components/Button'
import Swal from "sweetalert2";

export default {
    name: "Profile",

    components: {
        Button
    },

    data (){
        return {
            estados_brasileiros: ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"],
            userInfo: {}
        }
    },
    computed:{
        telefoneRegEx() {
            var re = new RegExp("^(?:[1-9]{2}| ?) ?(?:[1-9]|[1-9][1-9])[0-9]{3}-?[0-9]{4}$");
            return re.test(this.userInfo.telefone);
        },
    },
    mounted() {
        this.emitter.on('loadDataProfile', () => {
            this.loadData()
        });
    },
    methods: {
        async loadData(){
            await this.$store.dispatch('setUserInfo')
            try {
                this.userInfo = this.$store.getters.getUserInfo.data
            } catch(e) {
                this.userInfo = {}
            }
        },
        async updateUser() {
            //Se os required não forem nulos
            if(this.userInfo.email && this.userInfo.nome && this.userInfo.genero && this.userInfo.dataNascimento 
                && this.userInfo.telefone && this.userInfo.estado && this.userInfo.cidade && this.userInfo.formacao 
                && this.userInfo.distrito && this.userInfo.logradouro && this.userInfo.bairro && this.userInfo.cep)
            {   
                if(this.userInfo.numero !=null && this.userInfo.numero.length == 0){
                    this.userInfo.numero = '0';
                }

                //Se o telefone estiver no formato correto
                if(this.telefoneRegEx){
                    await this.$store.dispatch('setUpdateUser', this.userInfo)
                    await this.$store.dispatch('setUserInfo')
                    Swal.fire(
                        'Informações Atualizadas!',
                        'As informações das suas contas foram atualizadas',
                        'success'
                    )      
                    this.$emit('closeModal')
                }
            }
        },
        close() {
            this.$emit('closeModal')
        },

        /*--------------------------------
        |METODO MASCARA TELEFONE
        ----------------------------------*/
        mascaraTel(){
        //Mascara Telefone KEYUP (ao digitar)
        const ddd = this.userInfo.telefone.slice(0,2);
        const num1 = this.userInfo.telefone.slice(2,8);
        const num2 = this.userInfo.telefone.slice(8,12);
        if(this.userInfo.telefone.length == 3 && this.userInfo.telefone.charAt(2) != " "){
            this.userInfo.telefone = `${ddd} ${num1}`
        }
        if(this.userInfo.telefone.length == 9 && this.userInfo.telefone.charAt(2) == " " && this.userInfo.telefone.charAt(8) != "-"){
            this.userInfo.telefone = `${ddd}${num1}-${num2}`
        }
        },

        mascaraTelChange(){  
        //Mascara Telefone CHANGE, caso a pessoa só cole um valor
        if(this.userInfo.telefone.length > 2 && this.userInfo.telefone.length <=7 && this.userInfo.telefone.charAt(2) != " "){
            const part1 = this.userInfo.telefone.slice(0,2);
            const part2 = this.userInfo.telefone.slice(2,this.userInfo.telefone.length);
            this.userInfo.telefone = `${part1} ${part2}`
        }

        if(this.userInfo.telefone.length > 7 && this.userInfo.telefone.length <=11 && this.userInfo.telefone.charAt(2) != " " && this.userInfo.telefone.charAt(8) != "-"){
            const parte1 = this.userInfo.telefone.slice(0,2);
            const parte2 = this.userInfo.telefone.slice(2,7);
            const parte3 = this.userInfo.telefone.slice(7,11);
            this.userInfo.telefone = `${parte1} ${parte2}-${parte3}`
        }
        },

        /*--------------------------------
        |METODO MASCARA CEP
        ----------------------------------*/
        mascaraCEP(){  
        //Mascara CEP KEYUP (ao digitar)
        const parte1 = this.userInfo.cep.slice(0,2);
        const parte2 = this.userInfo.cep.slice(2,6);
        const parte3 = this.userInfo.cep.slice(6,9);

        if(this.userInfo.cep.length == 3 && this.userInfo.cep.charAt(2) != "."){
            this.userInfo.cep = `${parte1}.${parte2}`
        }
        if(this.userInfo.cep.length == 7 && this.userInfo.cep.charAt(2) == "." && this.userInfo.cep.charAt(6) != "-"){
            this.userInfo.cep = `${parte1}${parte2}-${parte3}`
        }
        },

        mascaraCepChange(){  
        //Mascara CEP CHANGE, caso a pessoa só cole um valor
        if(this.userInfo.cep.length > 2 && this.userInfo.cep.length <=5 && this.userInfo.cep.charAt(2) != "."){
            const part1 = this.userInfo.cep.slice(0,2);
            const part2 = this.userInfo.cep.slice(2,this.userInfo.cep.length);
            this.userInfo.cep = `${part1}.${part2}`
        }

        if(this.userInfo.cep.length > 5 && this.userInfo.cep.length <=8 && this.userInfo.cep.charAt(2) != "." && this.userInfo.cep.charAt(6) != "-"){
            const parte1 = this.userInfo.cep.slice(0,2);
            const parte2 = this.userInfo.cep.slice(2,5);
            const parte3 = this.userInfo.cep.slice(5,8);
            this.userInfo.cep = `${parte1}.${parte2}-${parte3}`
        }
        },
    },
}

</script>

<style scoped>

    .container{
        width: 100%;
        background-color: white;
    }

    .form-group{
        display: flex;
    }

    .title-style{
        font-size: 1.5rem;
        font-weight: 600;
        color: #656565;        
    }

    .question-style{
        width: 100%;
        font-size: 1rem;
        font-weight: 500;
        color: #656565;
    }

    .image-style{
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
        padding: 1rem;
    }

    .button-div{
        justify-content: space-between;
    }

    .input-personal {
        padding: 0.2rem 0.4rem;
        font-size: 0.938rem;
        font-weight: 400;
        border-radius: 8px;
        background: #FCFCFC;
        outline: none;
        border: 1px solid rgba(0, 0, 0, 0.11);
        font-weight: lighter;
        padding: 0.2rem 0.4rem;
        box-shadow: 1px 2px 6px -3px rgb(0 0 0 / 25%);
    }

        .disabled-style{
        background-color: #D0D0D0 !important;
        cursor: default;
        pointer-events: none;
    }

</style>
